import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { OddsHistoryMatchSummary } from "@/types/ApiResponses/OddsHistory";

export interface OddsHistoryMatchSearchParams {
  search: string;
  limit?: number;
}

export const searchOddsHistoryMatches = async (
  props: QueryProps<OddsHistoryMatchSearchParams>
): Promise<{ items: OddsHistoryMatchSummary[] }> => {
  const res = await api.client.get("/odds-history/matches", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
